import { Alert } from "@tine/designsystem-ui-react";
import { cn } from "@tine/designsystem-utils";
import { action } from "mobx";
import { observer } from "mobx-react-lite";

import { useEffect, useState } from "react";

import type { ToastType } from "../common/types/toastTypes";

import toastStore from "../stores/toastStore";

type SingleToastProps = {
   toast: ToastType;
};

const fadeDuration = 500;
const durationStyle = "duration-500";

const SingleToast = observer(({ toast }: SingleToastProps) => {
   const { duration, id, show: showProp, title, type, persist } = toast;
   const [show, setShow] = useState<boolean>(showProp);
   const [finished, setFinished] = useState(false);

   const variant = type === "success" ? "success" : type === "error" ? "error" : "information";

   useEffect(() => {
      if (persist) {
         return;
      }
      // Hides the toast after the duration time
      const timeoutId = setTimeout(() => {
         setShow(false);
      }, duration);

      return () => clearTimeout(timeoutId);
   }, [duration]);

   useEffect(() => {
      const timeoutId = setTimeout(() => {
         if (!show) {
            setFinished(true);
         }
      }, fadeDuration);
      return () => clearTimeout(timeoutId);
   }, [show]);

   if (finished) {
      return null;
   }

   const onClose = action(() => {
      setShow(false);
      toastStore.toasts = toastStore.toasts.filter((t) => t.id !== id);
   });

   const borderStyles = cn("border", {
      "border-error-600": variant === "error",
      "border-success-600": variant === "success"
   });
   const alertStyles = cn(borderStyles, "transition-opacity", durationStyle, {
      "opacity-100": show,
      "opacity-0": !show
   });
   return (
      <div className="m-3 w-96">
         <Alert variant={variant} title={title} className={alertStyles} onClose={onClose}>
            {toast.message.split("\n").map((line, i) => (
               <p key={`${i + 1}`}>{line}</p>
            ))}
         </Alert>
      </div>
   );
});

const ToastDisplay = () => (
   <div className="fixed top-0 left-0 z-40" data-testid="toast-display">
      {toastStore.toasts.map((toast) => (
         <SingleToast key={toast.id} toast={toast} />
      ))}
   </div>
);

export default observer(ToastDisplay);
